import constClass from '../../Constants/Constants';
import Common from '../Common/common';
import moment from 'moment';
import React from 'react';

const TicketIssue = ({ ticket,ticketIssueClick, backClick, disabled, siteId }) => {

  return (
    <div id="ticketUse" className="px-0-env">
      <div className="mx-3 mt-1 mb-3 bg-white border">
        <div className="row mx-0 px-3-env pt-2 pb-1 card-header">
          <div className="col py-1 px-1 align-self-center text-center">
            <h4 className="p-0 m-0">{ticket.ticket_name}</h4>
            {ticket.ticket_summary && <span className="p-0 m-0">{ticket.ticket_summary}</span>}
          </div>
        </div>
            {ticket.use_date &&
              <div className="row mx-0 px-3 pt-2 pb-1">
                <div className="col py-1 px-1 align-self-center text-center">
                  <p
                    className="mb-0 py-1 text-danger w-100">
                    このクーポンは使用済みです
                  </p>
                </div>
              </div>
            }
            {ticket.invalid_flag === constClass.FLAG.ON &&
              <div className="row mx-0 px-3 pt-2 pb-1">
                <div className="col py-1 px-1 align-self-center text-center">
                  <p
                    className="mb-0 py-1 text-danger w-100">
                    このクーポンは無効です
                  </p>
                </div>
              </div>
            }
        <div className="row mx-0 px-3 pt-2 pb-1 text-alert">
          {((ticket.ticket_image_url && ticket.use_date) || ticket.invalid_flag === constClass.FLAG.ON) &&
            <div className="col py-1 px-1 align-self-center text-center">
              {!ticket.hp_url && <div className="w-50 mx-auto ticketuse"><img className="w-100" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} /></div>}
              {ticket.hp_url &&
                <a href={Common.getExternalUrl(ticket.hp_url)} target="_blank" rel="noreferrer" className="text-digitalcard">
                    <div className='ticketuse'>
                      <img className="w-50" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} />
                    </div>
                  <br />
                  <u>公式サイトへ</u>
                </a>
              }
            </div>
          }
          {ticket.ticket_image_url && !ticket.use_date && ticket.invalid_flag !== constClass.FLAG.ON &&
            <div className="col py-1 px-1 align-self-center text-center">
              {!ticket.hp_url && <div className="w-50 mx-auto"><img className="w-100" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} /></div>}
              {ticket.hp_url &&
                <a href={Common.getExternalUrl(ticket.hp_url)} target="_blank" rel="noreferrer" className="text-digitalcard">
                    <img className="w-50" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} />
                  <br />
                  <u>公式サイトへ</u>
                </a>
              }
            </div>
          }
        </div>
        <div className="row mx-0 px-3 pt-1 pb-1">
          <div className="col py-1 px-1 align-self-center">
            <div className="row pb-3">
              <div className="col text-center">
                <span className="p-0 m-0">{Common.getBrString(ticket.ticket_detail)}</span>
              </div>
            </div>
            {ticket.ticket_notes &&
              <div className="row pb-1">
                <div className="col small">
                  【注意事項】
                  <span className="p-0 m-0">{Common.getBrString(ticket.ticket_notes)}</span>
                </div>
              </div>
            }
            <div className="row pb-3">
              <div className="col small">
                【有効期限】
                <br />
                <span className="p-0 m-0">{Common.getDateObject1(ticket.limit_date).str}</span>
              </div>
            </div>
            {/* {ticket.ticket_times > 1 &&
              <div className="row pb-1">
                <div className="col text-center small">
                  <span className="p-0 m-0">最大{ticket.ticket_times}回使用可能({ticket.t_ticket_use.length > 0 ? ticket.t_ticket_use.length + '回使用済み' : '未使用'})</span>
                </div>
              </div>
            } */}
            <div className="row pb-3">
              <div className="col">
                {(!ticket.use_date && ticket.invalid_flag !== constClass.FLAG.ON) &&
                  <div className="text-center">
                    <p
                      className="mb-0 py-1 text-alert w-100">
                      この画面をスタッフへご提示ください
                    </p>
                  </div>
                }
                {ticket.use_date &&
                  <div className="row p-0 m-0">
                    <div className="col-4 p-0 m-0 text-right">
                      使用日時
                    </div>
                    <div className="col-8 p-0 m-0 text-left">
                      {moment(ticket.use_date).format("YYYY/MM/DD HH:mm:ss")}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className="row">
              <div className="col">
                <button
                  className="btn btn-enable w-100"
                  disabled={disabled}
                  onClick={backClick}>
                  戻る
                </button>
              </div>
            </div>
          {(!ticket.use_date && ticket.invalid_flag !== constClass.FLAG.ON) &&
            <React.Fragment>
            <div className="row pt-3 mt-3 border-top">
              <div className="col">
                <div className="text-center">
                    <p
                      className="mb-0 py-1 text-secondary w-100">
                      以下のボタンは店舗用です。<br />
                      タップするとクーポンを使用します。
                    </p>
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                  <div>
                    <button onClick={ticketIssueClick(ticket.issue_count, ticket.ticket_id)}className="btn btn-secondary w-100">
                      クーポンを使用する
                    </button>
                  </div>
              </div>
            </div>
            </React.Fragment>
          }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TicketIssue;